import { guardianAlertService } from "../services/guardianAlertService";
import { openAlertDetails } from "./appNavigation";
import {
  mapAlertByCodeToDetailsShape,
  pickTicketIdFromAlert,
} from "./guardianAlertByCode";

function asList(payload) {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
}

/**
 * Extrai ticket/código do alerta já aninhado na solicitação (se a API enviar).
 */
function fromNestedAlert(nested) {
  if (!nested || typeof nested !== "object") return null;

  const ticketId =
    nested.last_ticket?.id ||
    nested.last_ticket?.ticket_id ||
    pickTicketIdFromAlert(nested) ||
    nested.ticket_id ||
    null;

  const alertId = nested.id || nested.alert_id || null;
  const codAlerta = nested.cod_alerta || null;

  if (!ticketId && !alertId && !codAlerta) return null;
  return { ticketId, alertId, codAlerta, alert: nested };
}

/**
 * Localiza o alerta criado a partir da solicitação (OneToOne alert_request).
 */
export async function resolveAlertLinkedToRequest(req) {
  if (!req?.id) return null;

  const nested =
    fromNestedAlert(req.fulfilled_alert) ||
    fromNestedAlert(req.alert) ||
    fromNestedAlert(req.created_alert);
  if (nested) return nested;

  const listPayload = await guardianAlertService.getGuardianAlerts();
  const alerts = asList(listPayload);
  const linked = alerts.find(
    (a) => a?.alert_request != null && String(a.alert_request) === String(req.id)
  );
  if (!linked) return null;

  return {
    ticketId: linked.last_ticket?.id || linked.last_ticket?.ticket_id || null,
    alertId: linked.id || linked.alert_id || null,
    codAlerta: linked.cod_alerta || null,
    alert: linked,
  };
}

/**
 * Abre a tela de detalhes do alerta (mesmo fluxo de "Visualizar").
 */
export async function openAlertFromAlertRequest(dispatch, navigate, req) {
  const linked = await resolveAlertLinkedToRequest(req);
  if (!linked) {
    throw new Error("Não foi possível localizar o alerta vinculado a esta solicitação.");
  }

  if (linked.ticketId) {
    openAlertDetails(dispatch, navigate, {
      ticketId: linked.ticketId,
      codAlerta: linked.codAlerta || undefined,
    });
    return;
  }

  if (linked.codAlerta) {
    try {
      const data = await guardianAlertService.getAlertByCode(linked.codAlerta);
      if (data?.success && data?.alert) {
        const ticketId = pickTicketIdFromAlert(data.alert);
        if (ticketId) {
          openAlertDetails(dispatch, navigate, {
            ticketId,
            codAlerta: data.alert.cod_alerta,
          });
          return;
        }
        openAlertDetails(dispatch, navigate, {
          codAlerta: data.alert.cod_alerta,
          preloadedAlert: mapAlertByCodeToDetailsShape(data.alert),
        });
        return;
      }
    } catch {
      // segue para fallback por lista completa
    }
  }

  if (linked.alertId) {
    const tickets = asList(await guardianAlertService.getCompleteAlerts());
    const match = tickets.find(
      (t) => String(t.alert_id) === String(linked.alertId)
    );
    if (match?.ticket_id) {
      openAlertDetails(dispatch, navigate, {
        ticketId: match.ticket_id,
        codAlerta: linked.codAlerta || undefined,
      });
      return;
    }
  }

  throw new Error("Alerta encontrado, mas sem ticket para visualizar.");
}
